import React from "react";
import { Card, Row, Stack } from "react-bootstrap";
import styled from "styled-components";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon/SvgIcon";
import IconContainer from "./IconContainer";
import { useNavigate } from "react-router-dom";

export interface MenuItemCardProps {
  titulo: string;
  ruta?: string;
  Icono: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  tamanoFuenteTitulo?: number;
  descripcion?: string;
  deshabilitada?: boolean;
}

function MenuItemCard({
  titulo,
  descripcion,
  ruta,
  Icono,
  tamanoFuenteTitulo,
  deshabilitada = false,
}: MenuItemCardProps) {
  const navigate = useNavigate();

  const onCardClick = () => {
    if (deshabilitada || !ruta) {
      return;
    }

    navigate(ruta);
  };

  return (
    <StyledCard onClick={onCardClick} $deshabilitada={deshabilitada}>
      <StyledCardHeader>
        <IconContainer className="pt-2">
          <Icono sx={{ fontSize: 75 }} />
        </IconContainer>
      </StyledCardHeader>
      <Card.Body>
        <Stack className="text-center">
          <StyledTitleRow className="mx-auto mb-2">
            <CardTitle fontSize={tamanoFuenteTitulo}>{titulo}</CardTitle>
          </StyledTitleRow>
          {descripcion && (
            <StyledDescriptionRow className="mx-auto mb-2 text-center">
              {descripcion}
            </StyledDescriptionRow>
          )}
        </Stack>
      </Card.Body>
    </StyledCard>
  );
}

const StyledCard = styled(Card)<{ $deshabilitada?: boolean }>`
  height: 100%;
  cursor: ${(props) => (props.$deshabilitada ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$deshabilitada ? 0.7 : 1)};
  &:hover {
    color: #333;
    background-color: ${(props) =>
      props.$deshabilitada ? "inherit" : props.theme.colors.light};
  }
`;

const StyledTitleRow = styled(Row)`
  height: 20%;
  width: 100%;
`;

const StyledDescriptionRow = styled(Row)`
  height: 30%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

const CardTitle = styled("h4")<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "20px")};
  font-weight: 500;
  color: #454545;
  text-transform: capitalize;
  letter-spacing: 0.05em;
`;

export default MenuItemCard;
